import { MaintenanceRequest } from '@/types/maintenance';

const maintenanceIssues = [
  'Grifo que Gotea',
  'Aire Acondicionado Averiado',
  'Enchufe Eléctrico No Funciona',
  'Problema de Plomería',
  'Malfunción de Cerradura de Puerta',
  'Ventana No Se Cierra',
  'Problema del Sistema de Calefacción',
  'Fregadero de Cocina Obstruido',
  'Ventilador de Baño Averiado',
  'Reemplazo de Lámpara',
  'Limpieza de Alfombra Requerida',
  'Retoque de Pintura Necesario',
  'Barandilla de Balcón Suelta',
  'Triturador de Basura Averiado',
  'Batería de Detector de Humo',
  'Prueba de Alarma de Incendio',
  'Mantenimiento de Ascensor',
  'Reparación de Equipo de Piscina',
  'Reparación de Equipo de Gimnasio',
  'Problema de Puerta de Estacionamiento'
];

const descriptions = [
  'El grifo de la cocina está goteando y necesita reparación',
  'La unidad de AC no está enfriando correctamente, necesita inspección',
  'El enchufe eléctrico en la sala de estar no funciona',
  'El fregadero del baño está obstruido y el agua se está acumulando',
  'El mecanismo de la cerradura de la puerta principal está atascado',
  'La ventana del dormitorio no se cierra correctamente',
  'El sistema de calefacción no funciona en invierno',
  'El fregadero de la cocina está completamente obstruido',
  'El ventilador de escape del baño hace ruido fuerte',
  'La lámpara de la sala de estar necesita reemplazo',
  'La alfombra tiene manchas que necesitan limpieza profesional',
  'La pintura de la pared se está despegando en varias áreas',
  'La barandilla del balcón está suelta e insegura',
  'La unidad del triturador de basura está atascada',
  'La batería del detector de humo necesita reemplazo',
  'El sistema de alarma de incendio necesita prueba anual',
  'El ascensor está haciendo ruidos extraños',
  'La bomba de la piscina no funciona correctamente',
  'La caminadora en el gimnasio está averiada',
  'La puerta del estacionamiento no responde al control remoto'
];

const residents = [
  { id: 'RES001', name: 'Juan Doe' },
  { id: 'RES002', name: 'Juana Smith' },
  { id: 'RES003', name: 'Miguel Johnson' },
  { id: 'RES004', name: 'Sara Wilson' },
  { id: 'RES005', name: 'David Brown' },
  { id: 'RES006', name: 'Lisa Davis' },
  { id: 'RES007', name: 'Roberto Miller' },
  { id: 'RES008', name: 'Jennifer García' },
  { id: 'RES009', name: 'Guillermo Rodriguez' },
  { id: 'RES010', name: 'María Martínez' }
];

const units = [
  { id: 'UNIT001', name: 'Unit 101' },
  { id: 'UNIT002', name: 'Unit 102' },
  { id: 'UNIT003', name: 'Unit 103' },
  { id: 'UNIT004', name: 'Unit 201' },
  { id: 'UNIT005', name: 'Unit 202' },
  { id: 'UNIT006', name: 'Unit 203' },
  { id: 'UNIT007', name: 'Unit 301' },
  { id: 'UNIT008', name: 'Unit 302' },
  { id: 'UNIT009', name: 'Unit 303' },
  { id: 'UNIT010', name: 'Unit 401' }
];

const blocks = [
  { id: 'BLOCK001', name: 'Block A' },
  { id: 'BLOCK002', name: 'Block B' },
  { id: 'BLOCK003', name: 'Block C' },
  { id: 'BLOCK004', name: 'Block D' }
];

const employees = [
  { id: 'EMP001', name: 'Miguel Johnson' },
  { id: 'EMP002', name: 'Tomás Wilson' },
  { id: 'EMP003', name: 'Cristóbal Davis' },
  { id: 'EMP004', name: 'Alejandro Brown' },
  { id: 'EMP005', name: 'Samuel Miller' }
];

const statuses: MaintenanceRequest['status'][] = ['Open', 'In Progress', 'On Hold', 'Resolved'];
const priorities: MaintenanceRequest['priority'][] = ['Low', 'Medium', 'High', 'Urgent'];

export const maintenanceRequests: MaintenanceRequest[] = Array.from({ length: 50 }, (_, idx) => {
  const issueIndex = idx % maintenanceIssues.length;
  const residentIndex = idx % residents.length;
  const unitIndex = idx % units.length;
  const blockIndex = idx % blocks.length;
  const employeeIndex = idx % employees.length;
  const statusIndex = idx % statuses.length;
  const priorityIndex = idx % priorities.length;
  
  const createdAt = new Date();
  createdAt.setDate(createdAt.getDate() - Math.floor(Math.random() * 30));
  
  const updatedAt = new Date(createdAt);
  updatedAt.setDate(updatedAt.getDate() + Math.floor(Math.random() * 7));
  
  return {
    id: `MNT${(idx + 1).toString().padStart(3, '0')}`,
    title: maintenanceIssues[issueIndex],
    description: descriptions[issueIndex],
    status: statuses[statusIndex],
    priority: priorities[priorityIndex],
    reportedBy: residents[residentIndex],
    apartmentUnit: units[unitIndex],
    block: blocks[blockIndex],
    assignedTo: employees[employeeIndex],
    workspace: {
      id: 'demo-workspace',
      name: 'Jardines Sunset',
      slug: 'demo-workspace'
    },
    attachments: Math.random() > 0.7 ? [
      {
        id: `ATT${(idx + 1).toString().padStart(3, '0')}`,
        name: 'Imagen del Problema',
        type: 'image',
        size: 1024 + Math.floor(Math.random() * 5000),
        path: `/documents/maintenance/MNT${(idx + 1).toString().padStart(3, '0')}/issue.jpg`,
        url: `https://example.com/images/issue-${idx + 1}.jpg`,
        uploadedAt: new Date(createdAt.getTime() + Math.floor(Math.random() * 24 * 60 * 60 * 1000))
      }
    ] : [],
    resolutionNotes: statuses[statusIndex] === 'Resolved' ? `Problema resuelto el ${updatedAt.toLocaleDateString()}. Todos los sistemas funcionando correctamente.` : undefined,
    comments: Math.random() > 0.5 ? [
      {
        id: `COM${(idx + 1).toString().padStart(3, '0')}`,
        content: 'Técnico asignado a este problema.',
        author: {
          id: employees[employeeIndex].id,
          name: employees[employeeIndex].name,
          type: 'employee' as const
        },
        createdAt: new Date(createdAt.getTime() + Math.floor(Math.random() * 24 * 60 * 60 * 1000))
      }
    ] : [],
    createdAt,
    updatedAt,
    activityRecords: [
      {
        timestamp: createdAt,
        type: 'created',
        performedBy: {
          id: residents[residentIndex].id,
          name: residents[residentIndex].name,
          displayName: residents[residentIndex].name
        }
      },
      ...(statuses[statusIndex] !== 'Open' ? [{
        timestamp: new Date(createdAt.getTime() + Math.floor(Math.random() * 24 * 60 * 60 * 1000)),
        type: 'updated' as const,
        performedBy: {
          id: 'user-1',
          name: 'Admin User',
          displayName: 'Admin User'
        },
        details: `Estado cambiado a ${statuses[statusIndex]}`
      }] : [])
    ]
  };
}); 